"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[4706],{

/***/ 70807:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const SERVER_TIMESTAMP_KEY = "server_timestamp";
const ONE_SECOND = 1e3;
const ONE_MINUTE = 60 * ONE_SECOND;
class ServerTimestampController {
  static getInstance() {
    var _a;
    this._instance = (_a = this._instance) != null ? _a : new ServerTimestampController();
    return this._instance;
  }
  constructor() {
    this.clearInterval = this._startTimer();
  }
  _startTimer() {
    const interval = setInterval(() => {
      const time = ServerTimestampController.getInstance().tick();
      this.setTime(time);
    }, ONE_MINUTE);
    return () => clearInterval(interval);
  }
  getTime() {
    const ts = localStorage.getItem(SERVER_TIMESTAMP_KEY);
    if (ts == null)
      return null;
    return new Date(ts);
  }
  setTime(date) {
    if (date == null)
      return;
    localStorage.setItem(SERVER_TIMESTAMP_KEY, date.toISOString());
  }
  tick() {
    const date = this.getTime();
    if (date == null)
      return null;
    date.setMinutes(date.getMinutes() + 1);
    this.setTime(date);
    return date;
  }
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ServerTimestampController);


/***/ }),

/***/ 22310:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FG": () => (/* binding */ useTimeContext),
/* harmony export */   "Fo": () => (/* binding */ TimeProvider)
/* harmony export */ });
/* unused harmony export TimeContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70807);


const TimeContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  getCurrentTime: null
});
const TimeProvider = ({
  children
}) => {
  const controller = _index__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getInstance */ .Z.getInstance();
  const value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => ({ getCurrentTime: () => controller.getTime() }),
    [controller]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TimeContext.Provider, {
    value
  }, children);
};
const useTimeContext = () => {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(TimeContext);
  if (context === void 0) {
    throw new Error("useTimeContext must be used within a TimeProvider");
  }
  return context;
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (TimeProvider)));


/***/ }),

/***/ 85538:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": () => (/* reexport safe */ _generated_base_gql__WEBPACK_IMPORTED_MODULE_1__.Vn),
/* harmony export */   "k": () => (/* reexport safe */ _useUiDefault__WEBPACK_IMPORTED_MODULE_0__.Z)
/* harmony export */ });
/* harmony import */ var _useUiDefault__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27753);
/* harmony import */ var _generated_base_gql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3047);




/***/ }),

/***/ 27753:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": () => (/* binding */ QUERY),
  "Z": () => (/* binding */ useUiDefault)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(41552);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(28205);
;// CONCATENATED MODULE: ./src/client/ui-default/__generated__/useUiDefault.gql.ts


const defaultOptions = {};
const UiDefaultHookDocument = lib/* gql */.Ps`
    query uiDefaultHook($args: GetUiDefaultInput!) {
  UiDefault(input: $args) {
    id
    namespace
    name
    scope
    value
  }
}
    `;
function useUiDefaultHookQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(UiDefaultHookDocument, options);
}
function useUiDefaultHookLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(UiDefaultHookDocument, options);
}
const UiDefaultHookUpsertDocument = lib/* gql */.Ps`
    mutation uiDefaultHookUpsert($args: UpsertUiDefaultInput!) {
  upsertUiDefault(input: $args) {
    id
    namespace
    name
    scope
    value
  }
}
    `;
function useUiDefaultHookUpsertMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(UiDefaultHookUpsertDocument, options);
}

;// CONCATENATED MODULE: ./src/client/ui-default/useUiDefault.ts


const QUERY = lib/* gql */.Ps`
  query uiDefaultHook($args: GetUiDefaultInput!) {
    UiDefault(input: $args) {
      id
      namespace
      name
      scope
      value
    }
  }
`;
const MUTATION = lib/* gql */.Ps`
  mutation uiDefaultHookUpsert($args: UpsertUiDefaultInput!) {
    upsertUiDefault(input: $args) {
      id
      namespace
      name
      scope
      value
    }
  }
`;
function useUiDefault({
  name,
  namespace,
  scope,
  defaultValue
}) {
  var _a;
  const { data, loading, error } = useUiDefaultHookQuery({
    variables: { args: { name, namespace, scope } }
  });
  const [upsertDefault] = useUiDefaultHookUpsertMutation();
  return {
    loading,
    error,
    uiDefault: data == null ? void 0 : data.UiDefault,
    value: data ? (_a = data == null ? void 0 : data.UiDefault) == null ? void 0 : _a.value : defaultValue,
    save: (value, options) => upsertDefault({
      variables: { args: { name, namespace, scope, value } },
      ...options
    })
  };
}


/***/ }),

/***/ 17279:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": () => (/* binding */ linkToUserSettings)
/* harmony export */ });
const linkToUserSettings = () => "/user-settings";


/***/ }),

/***/ 20589:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cc": () => (/* binding */ CURRENCY_BASE_DEFAULT),
/* harmony export */   "Pr": () => (/* binding */ territoryToCountryCode),
/* harmony export */   "Qd": () => (/* binding */ COUNTRY_CODES),
/* harmony export */   "YL": () => (/* binding */ BLOOD_PRESSURE_SYSTOLIC),
/* harmony export */   "b8": () => (/* binding */ countryCodeToTerritory),
/* harmony export */   "iP": () => (/* binding */ BLOOD_PRESSURE_DIASTOLIC),
/* harmony export */   "jQ": () => (/* binding */ TERRITORY),
/* harmony export */   "ov": () => (/* binding */ INPATIENT_TYPE),
/* harmony export */   "sl": () => (/* binding */ NEXT_OF_KIN_RELATIONSHIP_CODES),
/* harmony export */   "tE": () => (/* binding */ GENDER_CODES),
/* harmony export */   "tX": () => (/* binding */ MEDIA_QUERY_SMALL_DEVICE),
/* harmony export */   "w1": () => (/* binding */ MARITAL_STATUS_CODES),
/* harmony export */   "yo": () => (/* binding */ DECIMALS_PLACES_DEFAULT)
/* harmony export */ });
/* unused harmony exports INVESTIGATION_VITALS, BLOOD_PRESSURE_METRICS, PAYERS_OPTIONS, OUTPATIENT_TYPE, PAYMENT_METHODS */
const INVESTIGATION_VITALS = "vitals";
const BLOOD_PRESSURE_SYSTOLIC = "systolic";
const BLOOD_PRESSURE_DIASTOLIC = "diastolic";
const BLOOD_PRESSURE_METRICS = [
  BLOOD_PRESSURE_SYSTOLIC,
  BLOOD_PRESSURE_DIASTOLIC
];
const PAYERS_OPTIONS = [
  { value: "Patient/Guardian", label: "Patient/Guardian" },
  { value: "NHIF", label: "NHIF" },
  { value: "Linda Mama", label: "Linda Mama" },
  { value: "UHC", label: "UHC" },
  { value: "Exemption", label: "Exempt" },
  { value: "Waiver", label: "Waiver" }
];
const OUTPATIENT_TYPE = "Outpatient";
const INPATIENT_TYPE = "Inpatient";
const GENDER_CODES = {
  MALE: "m",
  FEMALE: "f",
  TRANSGENDER: "transgender"
};
const MARITAL_STATUS_CODES = {
  UNKNOWN: "UNK",
  SINGLE: "U",
  MARRIED: "M",
  DIVORCED: "L",
  WIDOWED: "W"
};
const NEXT_OF_KIN_RELATIONSHIP_CODES = {
  HUSBAND: "husband",
  WIFE: "wife",
  BROTHER: "brother",
  SISTER: "sister",
  FATHER: "father",
  MOTHER: "mother",
  CHILD: "child",
  FRIEND: "friend",
  OTHER: "other"
};
const COUNTRY_CODES = {
  KENYA: "KE",
  LEBANON: "LB",
  GHANA: "GH",
  NIGERIA: "NG",
  SYRIA: "SY",
  IRAQ: "IQ",
  UK: "GB",
  SOMALIA: "SO",
  AFGHANISTAN: "AF",
  \u00C5LAND_ISLANDS: "AX",
  ALBANIA: "AL",
  ALGERIA: "DZ",
  AMERICAN_SAMOA: "AS",
  ANDORRA: "AD",
  ANGOLA: "AO",
  ANGUILLA: "AI",
  ANTARCTICA: "AQ",
  ANTIGUA_AND_BARBUDA: "AG",
  ARGENTINA: "AR",
  ARMENIA: "AM",
  ARUBA: "AW",
  AUSTRALIA: "AU",
  AUSTRIA: "AT",
  AZERBAIJAN: "AZ",
  BAHAMAS: "BS",
  BAHRAIN: "BH",
  BANGLADESH: "BD",
  BARBADOS: "BB",
  BELARUS: "BY",
  BELGIUM: "BE",
  BELIZE: "BZ",
  BENIN: "BJ",
  BERMUDA: "BM",
  BHUTAN: "BT",
  BOLIVIA: "BO",
  BOSNIA_AND_HERZEGOVINA: "BA",
  BOTSWANA: "BW",
  BOUVET_ISLAND: "BV",
  BRAZIL: "BR",
  BRITISH_INDIAN_OCEAN_TERRITORY: "IO",
  BRUNEI_DARUSSALAM: "BN",
  BULGARIA: "BG",
  BURKINA_FASO: "BF",
  BURUNDI: "BI",
  CAMBODIA: "KH",
  CAMEROON: "CM",
  CANADA: "CA",
  CAPE_VERDE: "CV",
  CAYMAN_ISLANDS: "KY",
  CENTRAL_AFRICAN_REPUBLIC: "CF",
  CHAD: "TD",
  CHILE: "CL",
  CHINA: "CN",
  CHRISTMAS_ISLAND: "CX",
  COCOS_ISLANDS: "CC",
  COLOMBIA: "CO",
  COMOROS: "KM",
  CONGO: "CG",
  THE_DEMOCRATIC_REPUBLIC_OF_THE_CONGO: "CD",
  COOK_ISLANDS: "CK",
  COSTA_RICA: "CR",
  COTE_D_IVOIRE: "CI",
  CROATIA: "HR",
  CUBA: "CU",
  CYPRUS: "CY",
  CZECH_REPUBLIC: "CZ",
  DENMARK: "DK",
  DJIBOUTI: "DJ",
  DOMINICA: "DM",
  DOMINICAN_REPUBLIC: "DO",
  ECUADOR: "EC",
  EGYPT: "EG",
  EL_SALVADOR: "SV",
  EQUATORIAL_GUINEA: "GQ",
  ERITREA: "ER",
  ESTONIA: "EE",
  ETHIOPIA: "ET",
  FALKLAND_ISLANDS: "FK",
  FAROE_ISLANDS: "FO",
  FIJI: "FJ",
  FINLAND: "FI",
  FRANCE: "FR",
  FRENCH_GUIANA: "GF",
  FRENCH_POLYNESIA: "PF",
  FRENCH_SOUTHERN_TERRITORIES: "TF",
  GABON: "GA",
  GAMBIA: "GM",
  GEORGIA: "GE",
  GERMANY: "DE",
  GIBRALTAR: "GI",
  GREECE: "GR",
  GREENLAND: "GL",
  GRENADA: "GD",
  GUADELOUPE: "GP",
  GUAM: "GU",
  GUATEMALA: "GT",
  GUERNSEY: "GG",
  GUINEA: "GN",
  GUINEA_BISSAU: "GW",
  GUYANA: "GY",
  HAITI: "HT",
  HEARD_ISLAND_AND_MCDONALD_ISLANDS: "HM",
  HOLY_SEE: "VA",
  HONDURAS: "HN",
  HONG_KONG: "HK",
  HUNGARY: "HU",
  ICELAND: "IS",
  INDIA: "IN",
  INDONESIA: "ID",
  IRAN: "IR",
  IRELAND: "IE",
  ISLE_OF_MAN: "IM",
  ISRAEL: "IL",
  ITALY: "IT",
  JAMAICA: "JM",
  JAPAN: "JP",
  JERSEY: "JE",
  JORDAN: "JO",
  KAZAKHSTAN: "KZ",
  KIRIBATI: "KI",
  NORTH_KOREA: "KP",
  KOREA: "KR",
  KUWAIT: "KW",
  KYRGYZSTAN: "KG",
  LAO: "LA",
  LATVIA: "LV",
  LESOTHO: "LS",
  LIBERIA: "LR",
  LIBYA: "LY",
  LIECHTENSTEIN: "LI",
  LITHUANIA: "LT",
  LUXEMBOURG: "LU",
  MACAO: "MO",
  MACEDONIA: "MK",
  MADAGASCAR: "MG",
  MALAWI: "MW",
  MALAYSIA: "MY",
  MALDIVES: "MV",
  MALI: "ML",
  MALTA: "MT",
  MARSHALL_ISLANDS: "MH",
  MARTINIQUE: "MQ",
  MAURITANIA: "MR",
  MAURITIUS: "MU",
  MAYOTTE: "YT",
  MEXICO: "MX",
  MICRONESIA: "FM",
  MOLDOVA: "MD",
  MONACO: "MC",
  MONGOLIA: "MN",
  MONTSERRAT: "MS",
  MOROCCO: "MA",
  MOZAMBIQUE: "MZ",
  MYANMAR: "MM",
  NAMIBIA: "NA",
  NAURU: "NR",
  NEPAL: "NP",
  NETHERLANDS: "NL",
  NETHERLANDS_ANTILLES: "AN",
  NEW_CALEDONIA: "NC",
  NEW_ZEALAND: "NZ",
  NICARAGUA: "NI",
  NIGER: "NE",
  NIUE: "NU",
  NORFOLK_ISLAND: "NF",
  NORTHERN_MARIANA_ISLANDS: "MP",
  NORWAY: "NO",
  OMAN: "OM",
  PAKISTAN: "PK",
  PALAU: "PW",
  PALESTINE: "PS",
  PANAMA: "PA",
  PAPUA_NEW_GUINEA: "PG",
  PARAGUAY: "PY",
  PERU: "PE",
  PHILIPPINES: "PH",
  PITCAIRN: "PN",
  POLAND: "PL",
  PORTUGAL: "PT",
  PUERTO_RICO: "PR",
  QATAR: "QA",
  REUNION: "RE",
  ROMANIA: "RO",
  RUSSIA: "RU",
  RWANDA: "RW",
  SAINT_HELENA: "SH",
  SAINT_KITTS_AND_NEVIS: "KN",
  SAINT_LUCIA: "LC",
  SAINT_PIERRE_AND_MIQUELON: "PM",
  SAINT_VINCENT_AND_THE_GRENADINES: "VC",
  SAMOA: "WS",
  SAN_MARINO: "SM",
  SAO_TOME_AND_PRINCIPE: "ST",
  SAUDI_ARABIA: "SA",
  SENEGAL: "SN",
  SERBIA_AND_MONTENEGRO: "CS",
  SEYCHELLES: "SC",
  SIERRA_LEONE: "SL",
  SINGAPORE: "SG",
  SLOVAKIA: "SK",
  SLOVENIA: "SI",
  SOLOMON_ISLANDS: "SB",
  SOUTH_AFRICA: "ZA",
  SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS: "GS",
  SPAIN: "ES",
  SRI_LANKA: "LK",
  SUDAN: "SD",
  SURINAME: "SR",
  SVALBARD_AND_JAN_MAYEN: "SJ",
  SWAZILAND: "SZ",
  SWEDEN: "SE",
  SWITZERLAND: "CH",
  TAIWAN: "TW",
  TAJIKISTAN: "TJ",
  TANZANIA: "TZ",
  THAILAND: "TH",
  TIMOR_LESTE: "TL",
  TOGO: "TG",
  TOKELAU: "TK",
  TONGA: "TO",
  TRINIDAD_AND_TOBAGO: "TT",
  TUNISIA: "TN",
  TURKEY: "TR",
  TURKMENISTAN: "TM",
  TCI: "TC",
  TUVALU: "TV",
  UGANDA: "UG",
  UKRAINE: "UA",
  UAE: "AE",
  US: "US",
  UM: "UM",
  URUGUAY: "UY",
  UZBEKISTAN: "UZ",
  VANUATU: "VU",
  VENEZUELA: "VE",
  VIETNAM: "VN",
  BVGI: "VG",
  USVI: "VI",
  WF: "WF",
  WSAHARA: "EH",
  YEMEN: "YE",
  ZAMBIA: "ZM",
  ZIMBABWE: "ZW",
  OTHER: "OT"
};
const PAYMENT_METHODS = {
  CASH: "Cash",
  MPESA: "M-PESA"
};
const CURRENCY_BASE_DEFAULT = 10;
const DECIMALS_PLACES_DEFAULT = 2;
const TERRITORY = {
  KENYA: "kenya",
  LEBANON: "lebanon",
  GHANA: "ghana",
  NIGERIA: "nigeria",
  PAKISTAN: "pakistan"
};
const countryCodeToTerritory = {
  KE: TERRITORY.KENYA,
  LB: TERRITORY.LEBANON,
  GH: TERRITORY.GHANA,
  NG: TERRITORY.NIGERIA,
  PK: TERRITORY.PAKISTAN
};
const territoryToCountryCode = {
  [TERRITORY.KENYA]: COUNTRY_CODES.KENYA,
  [TERRITORY.LEBANON]: COUNTRY_CODES.LEBANON,
  [TERRITORY.GHANA]: COUNTRY_CODES.GHANA,
  [TERRITORY.NIGERIA]: COUNTRY_CODES.NIGERIA,
  [TERRITORY.PAKISTAN]: COUNTRY_CODES.PAKISTAN
};
const MEDIA_QUERY_SMALL_DEVICE = "(max-width:600px)";


/***/ }),

/***/ 68490:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": () => (/* binding */ isDevEnvironment),
/* harmony export */   "m": () => (/* binding */ isDeployedEnvironment)
/* harmony export */ });
const isDevEnvironment = () => ["127.0.0.1", "localhost"].includes(window.location.hostname) || window.location.hostname.includes("acceptance");
const isDeployedEnvironment = () => window.location.hostname.includes("acceptance") || window.location.hostname.includes("production");


/***/ }),

/***/ 89202:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42359);

function getLocationUrl() {
  const windowRef = _globals__WEBPACK_IMPORTED_MODULE_0__/* .windowExists */ .xE;
  if (!windowRef.location) {
    return "";
  }
  const {
    location: { protocol, origin }
  } = windowRef;
  const toReplace = `${protocol}//`;
  return origin.replace(toReplace, "");
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (getLocationUrl);


/***/ }),

/***/ 42359:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ji": () => (/* binding */ APP_VERSION),
/* harmony export */   "xE": () => (/* binding */ windowExists),
/* harmony export */   "y7": () => (/* binding */ sessionStorage)
/* harmony export */ });
/* unused harmony exports RUNTIME_CONFIG_PATH, localStorage */
const windowExists = typeof window !== "undefined" ? window : {};
const RUNTIME_CONFIG_PATH = "__RUNTIME_UI_CONFIG__";
const sessionStorage = windowExists.sessionStorage || null;
const localStorage = windowExists.localStorage || null;
const APP_VERSION = "4.5.3";


/***/ }),

/***/ 72769:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": () => (/* binding */ handleEventsourceDisconnect)
/* harmony export */ });
function handleEventsourceDisconnect({
  es,
  refetch
}) {
  let lastESErrorAt = 0;
  let interval = null;
  es.addEventListener("error", () => {
    lastESErrorAt = Date.now();
    if (!interval) {
      interval = setInterval(() => {
        const now = Date.now();
        if (now - lastESErrorAt > 5e3) {
          clearInterval(interval);
          interval = null;
          try {
            refetch();
          } catch (err) {
          }
        }
      }, 1e3);
    }
  });
}


/***/ }),

/***/ 73955:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": () => (/* binding */ randomId)
/* harmony export */ });
function randomId() {
  return Math.random().toString(36).slice(2);
}


/***/ }),

/***/ 55806:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": () => (/* binding */ toTitleCase)
/* harmony export */ });
function toTitleCase(str) {
  return str.replace(/[_-]/g, " ").replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
  });
}


/***/ }),

/***/ 59807:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LQ": () => (/* binding */ poundsToPence),
/* harmony export */   "Pt": () => (/* binding */ useConvertFromPoundsFactory),
/* harmony export */   "UN": () => (/* binding */ penceToPounds),
/* harmony export */   "YQ": () => (/* binding */ useConvertFromPenceFactory)
/* harmony export */ });
/* unused harmony exports inputStep, useConvertFromPence, useConvertFromPounds */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47707);
/* harmony import */ var decimal_js_light__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97290);
/* harmony import */ var decimal_js_light__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(decimal_js_light__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var elephant_web_client_billing_BillingProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78768);
/* harmony import */ var elephant_web_client_utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20589);





const penceToPounds = (0,ramda__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((currency, amountInPence) => {
  var _a;
  if (!amountInPence && amountInPence !== 0) {
    return void 0;
  }
  const currencyDecimals = (_a = currency == null ? void 0 : currency.decimal) != null ? _a : elephant_web_client_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .DECIMALS_PLACES_DEFAULT */ .yo;
  const amountInPenceDecimal = new decimal_js_light__WEBPACK_IMPORTED_MODULE_1__.Decimal(amountInPence);
  return amountInPenceDecimal.div(elephant_web_client_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .CURRENCY_BASE_DEFAULT */ .Cc ** currencyDecimals).toNumber();
});
const poundsToPence = (0,ramda__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((currency, amountInPounds) => {
  var _a;
  if (!amountInPounds && amountInPounds !== 0) {
    return void 0;
  }
  const currencyDecimals = (_a = currency == null ? void 0 : currency.decimal) != null ? _a : elephant_web_client_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .DECIMALS_PLACES_DEFAULT */ .yo;
  const amountInPoundsDecimal = new decimal_js_light__WEBPACK_IMPORTED_MODULE_1__.Decimal(amountInPounds);
  return amountInPoundsDecimal.mul(elephant_web_client_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .CURRENCY_BASE_DEFAULT */ .Cc ** currencyDecimals).toInteger().toNumber();
});
function inputStep(currency) {
  var _a;
  const showDecimals = !currency.format.compact;
  const decimalPlaces = (_a = currency.decimals) != null ? _a : DECIMALS_PLACES_DEFAULT;
  return showDecimals ? `${10 ** -decimalPlaces}` : "1";
}
function useConvertFromPenceFactory() {
  const currency = (0,elephant_web_client_billing_BillingProvider__WEBPACK_IMPORTED_MODULE_2__/* .useBillingCurrency */ .eZ)();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (amountInPence) => penceToPounds(currency, amountInPence),
    [currency]
  );
}
function useConvertFromPoundsFactory() {
  const currency = (0,elephant_web_client_billing_BillingProvider__WEBPACK_IMPORTED_MODULE_2__/* .useBillingCurrency */ .eZ)();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (amountInPounds) => poundsToPence(currency, amountInPounds),
    [currency]
  );
}
function useConvertFromPence(amountInPence) {
  const currency = useBillingCurrency();
  return useMemo(
    () => penceToPounds(currency, amountInPence),
    [amountInPence, currency]
  );
}
function useConvertFromPounds(amountInPounds) {
  const currency = useBillingCurrency();
  return useMemo(
    () => poundsToPence(currency, amountInPounds),
    [amountInPounds, currency]
  );
}


/***/ }),

/***/ 13856:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useCurrencyFormat)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var elephant_web_client_billing_BillingProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78768);


function useCurrencyFormat(overrideCurrency) {
  const billingCurrency = (0,elephant_web_client_billing_BillingProvider__WEBPACK_IMPORTED_MODULE_1__/* .useBillingCurrency */ .eZ)();
  const currency = overrideCurrency != null ? overrideCurrency : billingCurrency;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    if (!(currency == null ? void 0 : currency.format)) {
      return void 0;
    }
    const digits = 2;
    return new Intl.NumberFormat(currency.format.locale, {
      style: "currency",
      currency: currency.code,
      minimumFractionDigits: digits,
      maximumFractionDigits: digits
    });
  }, [currency]);
}


/***/ }),

/***/ 41075:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useFacility)
/* harmony export */ });
/* unused harmony export MY_CLINIC */
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24520);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41552);

const MY_CLINIC = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
  query myClinic {
    myClinic {
      uuid
      name
      organisation
      addresses {
        country
        state
        subCounty
        ward
        street
      }
    }
  }
`;
function transformFacilityData(myClinic) {
  return {
    id: myClinic.uuid,
    name: myClinic.name,
    organisation: myClinic.organisation,
    address: myClinic.addresses[0]
  };
}
function useFacility() {
  const { data, ...rest } = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(MY_CLINIC, {
    fetchPolicy: "cache-first"
  });
  return {
    data: data && transformFacilityData(data.myClinic),
    ...rest
  };
}


/***/ }),

/***/ 42197:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": () => (/* binding */ useFormatPenceFactory)
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var elephant_web_client_billing_BillingProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78768);
/* harmony import */ var elephant_web_client_utils_useCurrencyFormat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13856);
/* harmony import */ var elephant_web_client_utils_useConvertCurrency__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59807);




function useFormatPence(amountInPence, currencyInput) {
  const defaultCurrency = useBillingCurrency();
  const currency = currencyInput != null ? currencyInput : defaultCurrency;
  const currencyFormatter = useCurrencyFormat(currency);
  return useMemo(() => {
    if (!currencyFormatter) {
      return void 0;
    }
    const amountInPounds = penceToPounds(currency, amountInPence);
    return currencyFormatter.format(amountInPounds);
  }, [amountInPence, currencyFormatter, currency]);
}
function useFormatPenceFactory() {
  const currency = (0,elephant_web_client_billing_BillingProvider__WEBPACK_IMPORTED_MODULE_1__/* .useBillingCurrency */ .eZ)();
  const currencyFormatter = (0,elephant_web_client_utils_useCurrencyFormat__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(currency);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (amountInPence) => {
      const amountInPounds = (0,elephant_web_client_utils_useConvertCurrency__WEBPACK_IMPORTED_MODULE_3__/* .penceToPounds */ .UN)(currency, amountInPence);
      if (!currencyFormatter) {
        return void 0;
      }
      return currencyFormatter.format(amountInPounds);
    },
    [currency, currencyFormatter]
  );
}


/***/ }),

/***/ 19894:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useQuerystring)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58311);


function useQuerystring() {
  const [search] = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_1__/* .useSearchParams */ .lr)();
  const entries = Object.fromEntries(search.entries());
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => entries, [search]);
}


/***/ }),

/***/ 29346:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useTerritory),
/* harmony export */   "h": () => (/* binding */ useTerritoryCode)
/* harmony export */ });
/* harmony import */ var _elephant_healthcare_config_provider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23198);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20589);
/* harmony import */ var _text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55806);



function useTerritory(opts) {
  const { territory } = (0,_elephant_healthcare_config_provider__WEBPACK_IMPORTED_MODULE_0__/* .useConfig */ .ZR)();
  return (opts == null ? void 0 : opts.titleCase) ? (0,_text__WEBPACK_IMPORTED_MODULE_2__/* .toTitleCase */ .L)(territory) : territory;
}
function useTerritoryCode() {
  const territory = useTerritory();
  return _constants__WEBPACK_IMPORTED_MODULE_1__/* .territoryToCountryCode */ .Pr[territory];
}


/***/ }),

/***/ 91019:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": () => (/* binding */ useLazyUser)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _elephant_healthcare_user_context_provider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36547);


const useLazyUser = () => {
  var _a, _b;
  return (_b = (_a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_elephant_healthcare_user_context_provider__WEBPACK_IMPORTED_MODULE_1__/* .UserContext */ .St)) == null ? void 0 : _a.user) != null ? _b : null;
};


/***/ }),

/***/ 55541:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "k$": () => (/* binding */ DEFAULT_LANGUAGE),
/* harmony export */   "v0": () => (/* binding */ getBrowserLanguage)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var elephant_web_client_common_i18n_getSupportedLanguage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16295);
/* harmony import */ var elephant_web_client_common_i18n_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55046);
/* harmony import */ var elephant_web_client_utils_useUser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91019);




const DEFAULT_LANGUAGE = elephant_web_client_common_i18n_constants__WEBPACK_IMPORTED_MODULE_2__/* .USER_LANGUAGE_CODES.ENGLISH */ .d$.ENGLISH;
function getBrowserLanguage() {
  return (0,elephant_web_client_common_i18n_getSupportedLanguage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(window.navigator.languages) || (0,elephant_web_client_common_i18n_getSupportedLanguage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(window.navigator.language) || DEFAULT_LANGUAGE;
}
const useUserLanguage = () => {
  var _a;
  const userLang = (_a = (0,elephant_web_client_utils_useUser__WEBPACK_IMPORTED_MODULE_3__/* .useLazyUser */ .x)()) == null ? void 0 : _a.language;
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(
    () => (0,elephant_web_client_common_i18n_getSupportedLanguage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(userLang) || getBrowserLanguage(),
    [userLang]
  );
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useUserLanguage);


/***/ }),

/***/ 67858:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useUserRole)
/* harmony export */ });
/* harmony import */ var _elephant_healthcare_user_context_provider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36547);

function useUserRole() {
  return (0,_elephant_healthcare_user_context_provider__WEBPACK_IMPORTED_MODULE_0__/* .useUserContext */ .SE)().roleName;
}


/***/ }),

/***/ 43576:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": () => (/* binding */ lowercaseCharRegex),
/* harmony export */   "S$": () => (/* binding */ singleNumberMinRegex),
/* harmony export */   "qr": () => (/* binding */ specialCharRegex)
/* harmony export */ });
/* unused harmony exports fieldRequired, fieldNotEmpty, fieldValidDate, validDOB, fieldValidDOB, validateIf, minLength, maxLength, fixedLength, password, email, greaterThanZero, positiveValue, validateCreator */
/* harmony import */ var elephant_web_client_services_dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15063);
/* harmony import */ var elephant_web_client_forms_validation_messages__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31160);


const required = (message) => (value) => !value || value === "" ? message : void 0;
const fieldRequired = required(elephant_web_client_forms_validation_messages__WEBPACK_IMPORTED_MODULE_1__/* .validationMessages.mixed.required */ .K1.mixed.required);
const notEmpty = (message) => (value) => value === "" ? message : void 0;
const fieldNotEmpty = notEmpty(elephant_web_client_forms_validation_messages__WEBPACK_IMPORTED_MODULE_1__/* .validationMessages.mixed.required */ .K1.mixed.required);
const validDate = (message) => (value) => !value || new Date(value) !== "Invalid Date" && !Number.isNaN(new Date(value)) ? void 0 : message;
const fieldValidDate = validDate(elephant_web_client_forms_validation_messages__WEBPACK_IMPORTED_MODULE_1__/* .validationMessages.date.valid */ .K1.date.valid);
const validDOB = (message) => (value) => {
  const firstValidDate = (0,elephant_web_client_services_dayjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)().subtract(110, "years");
  const now = (0,elephant_web_client_services_dayjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
  const date = (0,elephant_web_client_services_dayjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(value);
  return value && (!date.isValid() || date.isBefore(firstValidDate) || now.isBefore(date)) ? message : void 0;
};
const fieldValidDOB = validDOB(elephant_web_client_forms_validation_messages__WEBPACK_IMPORTED_MODULE_1__/* .validationMessages.date.dob */ .K1.date.dob);
const validateIf = (fieldName, requiredCheck) => (value, values) => {
  if (values == null ? void 0 : values[fieldName]) {
    return requiredCheck(value);
  }
  return void 0;
};
const minLength = (min) => {
  const msg = { ...validationMessages.string.min, values: { min } };
  return (value) => value && value.length < min ? msg : void 0;
};
const maxLength = (max) => {
  const msg = { ...validationMessages.string.max, values: { max } };
  return (value) => value && value.length > max ? msg : void 0;
};
const fixedLength = (len) => {
  const msg = { ...validationMessages.string.length, values: { length: len } };
  return (value) => value && value.length !== len ? msg : void 0;
};
const specialCharRegex = /^(?=.*[*" !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~"*]).*[a-zA-Z\d*" !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~"*]$/;
const singleNumberMinRegex = /^(?=.*\d).*[a-zA-Z\d*" !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~"*]$/;
const lowercaseCharRegex = /^(?=.*[a-z]).*[a-zA-Z\d*" !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~"*]$/;
const password = (value) => {
  if (!value) {
    return void 0;
  }
  const min = 6;
  if (value.length < min) {
    return { ...validationMessages.string.min, values: { min } };
  }
  if (!specialCharRegex.test(value)) {
    return validationMessages.string.specialChar;
  }
  if (!singleNumberMinRegex.test(value)) {
    return validationMessages.string.singleNumber;
  }
  if (!lowercaseCharRegex.test(value)) {
    return validationMessages.string.lowercaseChar;
  }
  return void 0;
};
const email = (value) => value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,11}$/i.test(value) ? validationMessages.string.email : void 0;
const greaterThanZero = (value) => value && value > 0 ? void 0 : validationMessages.number.greaterThanZero;
const positiveValue = (value) => value && value > 0 || value === 0 || value === "0" ? void 0 : validationMessages.number.positive;
const recursiveValidation = (checkersObject, values, obj = {}) => {
  const aux = obj;
  const result = Object.keys(checkersObject).reduce((acc, name) => {
    const checkers = checkersObject[name];
    const current = values == null ? void 0 : values[name];
    if (Object.prototype.toString.call(checkers) === "[object Object]") {
      aux[name] = recursiveValidation(checkers, current, aux[name]);
      if (values)
        return aux;
      return {};
    }
    if ({}.toString.call(checkers[0]) === "[object Function]") {
      const validateValue = checkers.find(
        (checker) => checker(current, values)
      );
      if (validateValue)
        aux[name] = validateValue(current, values);
      return aux;
    }
    if (current) {
      aux[name] = current.map(
        (row) => recursiveValidation(checkers[0], row, {})
      );
      return aux;
    }
    return {};
  }, {});
  return result;
};
const validateCreator = (checkersObject) => (values) => recursiveValidation(checkersObject, values);


/***/ }),

/***/ 55036:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": () => (/* binding */ linkToWardPatientList)
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28183);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);

const appendSearch = (params) => {
  return (0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(params, { addQueryPrefix: true });
};
function linkToWardPatientList(search = {}) {
  return `/ward-patient-list${appendSearch(search)}`;
}


/***/ }),

/***/ 50215:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": () => (/* binding */ WARD_AND_PATIENT_QUERY),
/* harmony export */   "r": () => (/* binding */ PATIENT_TRIAGE_STATUSES)
/* harmony export */ });
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24520);
/* harmony import */ var _patient_triage_useTriageStatus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58011);


const WARD_AND_PATIENT_QUERY = _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps`
  query WardPatientList($clinicUuid: String!) {
    facilityLocations(input: { clinicUuids: [$clinicUuid], active: true, hasPatients: true }) {
      _id
      name
      patients {
        uuid
        name
        dob
        gender
        diagnoses
        admittedAt
      }
    }
  }
`;
const PATIENT_TRIAGE_STATUSES = _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps`
  query patientTriageStatuses($patientUuids: [String]!) {
    patientTriageStatuses(patientUuids: $patientUuids) {
      ...PatientTriageStatus
    }
  }
  ${_patient_triage_useTriageStatus__WEBPACK_IMPORTED_MODULE_0__/* .PatientTriageStatusFragment */ .J6}
`;


/***/ })

}]);